/* eslint-disable no-tabs */
<template>
  <div id="index" class="home" @click="closePopup">
    <HeaderCommon></HeaderCommon>
    <BannerSection></BannerSection>
    <HotSection></HotSection>
    <InformationSection></InformationSection>
    <AboutUsSection></AboutUsSection>
    <OfferSection></OfferSection>
    <CoreTeamSection></CoreTeamSection>
    <PlanSection></PlanSection>
    <CommunityPartnerSection @func="toggleQrCode"></CommunityPartnerSection>
    <div class="gray-mask" v-if="isShow"></div>
    <div class="wechat-pop-wrapper" v-if="isShow">
      <div class="close-pop" @click="toggleQrCode(false)"></div>
      <div class="pop-content">
        <div class="pop-title" v-text="$t('home.scan_qrcode')"></div>
        <div class="pop-qrcode">
          <img src="../../assets/img/wechat_qrcode.png" alt="wechat_qrcode" />
        </div>
      </div>
    </div>
    <ScrollToTop></ScrollToTop>
    <FooterCommon></FooterCommon>
  </div>
</template>

<script>
import HeaderCommon from './template/HeaderCommon'
import FooterCommon from './template/FooterCommon'
import ScrollToTop from './template/ScrollToTop'
import BannerSection from './index/bannerSection'
import HotSection from './index/hotSection'
import InformationSection from './index/informationSection'
import AboutUsSection from './index/aboutUsSection'
import OfferSection from './index/offerSection'
import CoreTeamSection from './index/coreTeamSection'
import PlanSection from './index/planSection'
import CommunityPartnerSection from './index/communityPartnerSection'
export default {
  data () {
    return {
      animationArray: [true, false, false, false, false, false, false, false],
      isShow: false
    }
  },
  components: {
    HeaderCommon,
    FooterCommon,
    ScrollToTop,
    BannerSection,
    HotSection,
    InformationSection,
    AboutUsSection,
    OfferSection,
    CoreTeamSection,
    PlanSection,
    CommunityPartnerSection
  },
  methods: {
    toggleQrCode (data) {
      this.isShow = data
    },
    closePopup () {
      $('.menu-popup-box').removeClass('show')
    },
  },
  mounted () {
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/pc";
@import "~@/assets/scss/wap";
</style>



// WEBPACK FOOTER //
// src/components/pc/Index.vue